import { Bell, BellOff } from "lucide-react";
import { DASHBOARD_LABELS } from "../messages";
import { DeliveryStatusEnum, ShippingRecipient } from "../types";

const DELIVERY_STATUS_LABELS: Record<DeliveryStatusEnum, string> = {
  [DeliveryStatusEnum.DELIVERED]: DASHBOARD_LABELS.STATUS_DELIVERED,
  [DeliveryStatusEnum.FAILED]: DASHBOARD_LABELS.STATUS_FAILED,
  [DeliveryStatusEnum.HARD_BOUNCE]: DASHBOARD_LABELS.STATUS_HARD_BOUNCE,
};

const DELIVERY_STATUS_CLASS_NAME: Record<DeliveryStatusEnum, string> = {
  [DeliveryStatusEnum.DELIVERED]:
    "border-green-200 bg-green-100 text-green-800",
  [DeliveryStatusEnum.FAILED]: "border-red-200 bg-red-100 text-red-800",
  [DeliveryStatusEnum.HARD_BOUNCE]:
    "border-red-300 bg-red-200 text-red-900",
};

interface DeliveryBadgesProps {
  recipient: ShippingRecipient;
}

export function DeliveryBadges({ recipient }: DeliveryBadgesProps): JSX.Element {
  const readConfirmed: boolean = !!recipient.read_confirmed_at;

  return (
    <div className="flex flex-col gap-1">
      <span
        className={`w-fit rounded-full border px-2 py-0.5 text-xs font-medium ${
          DELIVERY_STATUS_CLASS_NAME[recipient.status]
        }`}
      >
        {DELIVERY_STATUS_LABELS[recipient.status]}
      </span>

      {readConfirmed ? (
        <span
          className="flex items-center gap-1 text-xs text-blue-700"
          title={DASHBOARD_LABELS.READ_CONFIRMED_TOOLTIP(
            new Date(recipient.read_confirmed_at as string).toLocaleString(
              "pt-BR"
            )
          )}
        >
          <Bell className="h-3 w-3" />
          {DASHBOARD_LABELS.READ_CONFIRMED}
        </span>
      ) : (
        <span
          className="flex items-center gap-1 text-xs text-gray-500"
          title={DASHBOARD_LABELS.READ_NOT_CONFIRMED_TOOLTIP}
          tabIndex={0}
        >
          <BellOff className="h-3 w-3" />
          {DASHBOARD_LABELS.READ_NOT_CONFIRMED}
        </span>
      )}
    </div>
  );
}
